<template>
<v-layout
    fluid
    fill-height
    column
    class="pa-0 ma-0 proof-wrapper"
    fill-width
  >
  <transition name="fade" mode="out-in">
    <router-view></router-view>
  </transition>
  <div style="text-align: center;" v-if="step < steps.length - 1">
      <v-btn
      v-if="showNext"
        class="btn-next"
        color="accent"
        medium
        depressed=""
        @click="next"
      >
        {{ $t('next_step') }}
      </v-btn>
    </div>
  </v-layout>
</template>

<script>
import routes from '@/route_names'
import EventBus from '@/event_bus'
export default {
  name: 'ProofView',
  data: function() {
    const steps = this.buildSteps()
    return {
      steps: steps,
      step: steps.indexOf(this.$router.currentRoute.name),
      showNext: false
    }
  },
  mounted: function() {
    const vm = this
    this.$store.subscribe((mutation, state) => {
      if (mutation.type === 'user/setUser') {
        vm.steps = vm.buildSteps()
        vm.step = vm.steps.indexOf(vm.$router.currentRoute.name)
      }
    })
    EventBus.$on('PROOF_NEXT', vm.next)
  },
  beforeDestroy(){
    EventBus.$on('PROOF_NEXT', this.next)
  },
  watch: {
    $route(to, from) {
      this.step = this.steps.indexOf(to.name)
      if(to.name === routes.PROOF_APPEARANCE
      ){
        this.showNext = false
      }
      else{
        this.showNext = true
      }
    }
  },
  methods: {
    buildSteps() {
      const customize = []
      const enabledMetrics = this.$store.getters['campaign/enabledMetrics']
      if (enabledMetrics.indexOf('NPS') > -1) {
        customize.push(routes.PROOF_CARDS_NPS)
      }
      if (enabledMetrics.indexOf('CSAT') > -1) {
        customize.push(routes.PROOF_CARDS_CSAT)
      }
      if (enabledMetrics.indexOf('CES') > -1) {
        customize.push(routes.PROOF_CARDS_CES)
      }
      return [
        routes.PROOF_APPEARANCE,
        routes.PROOF_CARDS,
        ...customize,
        routes.PROOF_SETTINGS,
        routes.PROOF_PUBLISH
      ]
    },
    next() {
      console.log(this.step, this.$router.currentRoute.name)
      this.$router.push({ name: this.steps[this.step + 1] })
    }
  }
}
</script>

<style lang="stylus" >
.proof-wrapper {
    width 100%
    .btn-next {
        height 40px
        padding-left 40px
        padding-right 40px
        font-weight 500
    }
}</style>
